import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-struttura',
  templateUrl: './struttura.component.html',
  styleUrl: './struttura.component.css'
})
export class StrutturaComponent implements OnInit {

  constructor(private router: Router, private renderer: Renderer2) { }

  carica: boolean = true;

  ngOnInit(): void {

    // Faccio aspettare mezzo secondo e rimuovo il caricamento
    setTimeout(() => {
      this.carica = false;
    }, 500);

    // Ogni volta che viene cambiato la route
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd), map(() => {
      return event;
    })).subscribe(() => {

      // Setto il caricamento a true
      this.carica = true;

      // Faccio aspettare mezzo secondo e rimuovo il caricamento
      setTimeout(() => {
        this.carica = false;
      }, 500);

    });

  }

}
